import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtAZN } from "@/lib/api";
import { Field } from "@/components/AuthLayout";

export const PromoAdmin = () => {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ code: "", amount: "1", max_uses: "20", duration_minutes: "60" });

  const load = useCallback(async () => { const { data } = await api.get("/admin/promos"); setList(data); }, []);
  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/promos", { code: f.code, amount: Number(f.amount), max_uses: Number(f.max_uses), duration_minutes: Number(f.duration_minutes) });
      toast.success("Promokod yaradıldı");
      setF({ ...f, code: "" }); load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const off = async (code) => {
    try { await api.post(`/admin/promos/${encodeURIComponent(code)}/deactivate`); toast.success("Promokod dayandırıldı"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="grid lg:grid-cols-[360px_1fr] gap-6">
      <form noValidate onSubmit={create} className="rounded-2xl border border-white/10 bg-[#111] p-6 space-y-4 h-fit" data-testid="promo-form">
        <h3 className="font-display font-bold">Yeni promokod</h3>
        <Field label="Kod" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase() })} placeholder="BONUS2026" data-testid="promo-code-input" />
        <Field label="Hər nəfərə (AZN)" type="number" step="0.01" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="promo-amount-input" />
        <Field label="Neçə nəfər aktiv edə bilər" type="number" value={f.max_uses} onChange={(e) => setF({ ...f, max_uses: e.target.value })} data-testid="promo-max-uses-input" />
        <Field label="Müddət (dəqiqə)" type="number" value={f.duration_minutes} onChange={(e) => setF({ ...f, duration_minutes: e.target.value })} data-testid="promo-duration-input" />
        <button className="btn-gold w-full rounded-full py-3 font-display font-bold" data-testid="promo-create-btn">Yarat</button>
      </form>
      <div className="rounded-2xl border border-white/10 bg-[#111] divide-y divide-white/5 h-fit" data-testid="promo-list">
        {list.length === 0 && <p className="p-5 text-sm text-zinc-500">Promokod yoxdur</p>}
        {list.map((p) => (
          <div key={p.code} className="flex flex-wrap items-center gap-4 px-5 py-3 text-sm" data-testid={`promo-row-${p.code}`}>
            <span className="font-display font-bold text-[#FFD700] min-w-[120px]">{p.code}</span>
            <span>{fmtAZN(p.amount)} / nəfər</span>
            <span className="text-zinc-400" data-testid={`promo-uses-${p.code}`}>{p.uses} / {p.max_uses}</span>
            <span className="text-zinc-500 text-xs">Bitir: {new Date(p.expires_at).toLocaleString("az-AZ")}</span>
            <span className={`ml-auto text-xs rounded-full px-3 py-1 ${p.active_now ? "text-emerald-400 bg-emerald-400/10" : "text-zinc-400 bg-white/5"}`}>{p.active_now ? "Aktiv" : "Bitib"}</span>
            {p.active_now && <button onClick={() => off(p.code)} className="text-xs text-red-400 hover:underline" data-testid={`promo-off-${p.code}`}>Dayandır</button>}
          </div>
        ))}
      </div>
    </div>
  );
};
